const { Component } = wp.element;

class LinkItem extends Component {

  constructor( props ) {
    super( props )
    this.handleClick = this.handleClick.bind( this );
  }

  handleClick( e ) {
    e.preventDefault();
    if ( this.props.active ) {
      return;
    }
    if ( this.props.clickHandler ) {
      this.props.clickHandler( this.props.number );
    }
  }

  render() {
    const listClass = ['page-item'];
    if ( this.props.active ) {
      listClass.push( 'active' );
    }
    return (
        <li className={ listClass.join( ' ' ) }>
          <a className="page-link" href="#" onClick={ this.handleClick }>{ this.props.number }</a>
        </li>
    );
  }
}

export class Pagination extends Component {

  shouldShow( target ) {
    const enoughLength = 5 < this.props.total;
    switch ( target ) {
      case 'prev':
        return enoughLength && 1 < this.props.current;
      case 'next':
        return enoughLength && this.props.current < this.props.total;
      default:
        return enoughLength;
    }
  }

  numberList() {
    // Calc left pad.
    let pages = [ this.props.current ];
    const rightPadDiff = this.props.total - this.props.current;
    for ( let minus = 1; minus < 5; minus++ ) {
      const thisValue = this.props.current + ( minus * -1 );
      if ( 1 > thisValue ) {
        continue;
      }
      if ( 2 < minus ) {
        const leftPossibility = minus - 2;
        if ( 2 < leftPossibility + rightPadDiff ) {
          continue;
        }
      }
      pages.unshift( thisValue );
    }
    // Calc right pad.
    for ( let plus = 1; plus < 5; plus++ ) {
      const thisValue = plus + this.props.current;
      if ( this.props.total < thisValue ) {
        continue;
      }
      if ( 2 < plus ) {
        if ( 3 <= this.props.current && 5 < plus + this.props.current ) {
          continue;
        }
      }
      pages.push( thisValue );
    }
    return pages;
  }

  handleClick( number, e = null ) {
    if ( e ) {
      e.preventDefault();
    }
    this.props.onNumberChange( number );
  }

  render() {
    const className = [ 'mx-auto', 'justify-content-center', this.props.py ? `py-${this.props.py}` : 'py-5' ];
    return ( 1 < this.props.total) ? (
      <div className={ className.join( ' ' ) }>
        <ul className="pagination center-pagination">

          { ( this.shouldShow( 'prev' ) ) ? (
            <li className="page-item">
              <a className="page-link box-shadow-none" href="#" tabIndex="-1" onClick={ ( e ) => { this.handleClick( this.props.current - 1, e ) }}>
                <i className="ti ti-angle-left"/> 前へ
              </a>
            </li>
          ) : null }

          { this.numberList().map( ( number ) => {

            return (
              <LinkItem number={number} active={ this.props.current === number } clickHandler={ number => { this.handleClick( number ) } } />
            );
          } ) }

          { this.shouldShow( 'next' ) ? (
            <li className="page-item">
              <a className="page-link box-shadow-none" href="#" onClick={ e => this.handleClick( this.props.current + 1, e ) }>
                次へ <i className="ti ti-angle-right" />
              </a>
            </li>
          ) : null }

        </ul>
      </div>
    ) : null;
  }

}
